import { useMachine } from '@xstate/react';
import { StepsCheckout } from './StepsCheckout';
import Suscripcion from '../Common/banner/Suscripcion';
import { LoginLayout } from '@lana-ui/login';
import { CheckoutMachine } from '../../Machines/CheckoutMachine';
import Meses from '../../Models/Meses';

const BaseLayout = () => {
    const [state, send] = useMachine(CheckoutMachine);
    const { montoTotal, montoProporcional, montoMesSiguiente, tieneClub, mesActual, mesSiguiente, mesesDescuento, montoFinal, beneficios, isPlanAnual } = state.context.datosCarrito;

    const enabledBack = state.matches('realizarPago') ? () => send('CANCELAR', { datosPersonales: state.context.datosPersonales }) : null;
    const showCart = state.context.dataObtenerMontoService !== '' && state.context.showCart;

    return (
        <LoginLayout showArrowBack={enabledBack}>
            <StepsCheckout state={state} send={send} />
            {showCart && (
                <Suscripcion
                    isPlanAnual={isPlanAnual}
                    conClub={tieneClub}
                    precioTotal={montoTotal}
                    mesProporcional={Meses[mesActual]}
                    mesProporcionalPrecio={montoProporcional}
                    mesSuscripcion={Meses[mesSiguiente]}
                    mesSuscripcionPrecio={montoMesSiguiente}
                    mesesDescuento={mesesDescuento}
                    precioFinal={montoFinal}
                    cambiarPlanOnClick={() => (window.location.href = state.context.URLRef)}
                    features={beneficios}
                    state={state}
                    isConfirmacion={state.matches('gracias') || state.matches('ingresarDomicilio') || state.matches('domiciliosGuardados')}
                />
            )}
        </LoginLayout>
    );
};

export default BaseLayout;
